import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "不足報告", enum: "A" },
  { value: 2, text: "過剰報告", enum: "B" },
  { value: 3, text: "実績調整", enum: "C" },
]);
